__turbopack_context__.v({
  "tab": "Tab-module-scss-module__yY0_yW__tab",
  "tabActive": "Tab-module-scss-module__yY0_yW__tabActive",
});
